<div [ngClass]="variant === 'reports' ? 'reports-nav w-full' : ''">
  <!-- Individual / Corporate placeholder (reports + mobile only, styled via CSS;
       not wired up yet) -->
  <div *ngIf="variant === 'reports'" class="ind-corp-toggle">
    <button type="button" class="ind-corp-btn ind-corp-active">
      <img src="assets/icons/user.svg" alt="" />
      <span i18n="@@individual">Individual</span>
    </button>
    <button type="button" class="ind-corp-btn">
      <img src="assets/icons/corporate.svg" alt="" />
      <span i18n="@@corporate">Corporate</span>
    </button>
  </div>

  <div
    class="nav-child-tabs flex items-center bg-primary px-2 py-2 rounded-lg gap-x-3.5"
    *ngIf="navButtons?.length > 0"
  >
    <div *ngFor="let btn of navButtons" class="nav-child-item">
      <button
        [disabled]="btn.navStatus === 'not-active'"
        [matTooltip]="btn.navStatus === 'not-active' ? 'Coming Soon' : ''"
        *hasPermissions="btn.perms"
        (click)="trigger(btn)"
        [ngClass]="
          isActive(btn)
            ? 'bg-white text-primary/95'
            : 'bg-primary text-white/95'
        "
        [class.nav-child-active]="isActive(btn)"
        [class]="
          'nav-child-btn flex rounded-lg gap-x-3.5 h-[35px] items-center justify-center p-2  '
        "
        mat-raised-button
        data-toggle="tooltip"
        data-placement="left"
      >
        <img
          class="nav-child-icon"
          [ngClass]="isActive(btn) ? 'filter-primary' : ''"
          [src]="btn.icon"
          alt=""
        />
        <span *ngIf="btn.name">{{ btn.name }}</span>
      </button>
    </div>
  </div>
</div>
